import { useEffect, useState, useCallback } from "react";

const KEY = "td_distance_units";

export function useUnits() {
  const [units, setUnits] = useState(() => localStorage.getItem(KEY) || "km");

  const update = useCallback((u) => {
    localStorage.setItem(KEY, u);
    setUnits(u);
    window.dispatchEvent(new Event("td-units-changed"));
  }, []);

  useEffect(() => {
    const handler = () => setUnits(localStorage.getItem(KEY) || "km");
    window.addEventListener("td-units-changed", handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener("td-units-changed", handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  return { units, setUnits: update };
}

export function formatDistance(km, { units, compact = false } = { units: "km" }) {
  if (km == null || Number.isNaN(km)) return "—";
  if (units === "mi") {
    const mi = km * 0.621371;
    return compact ? `${mi.toFixed(mi < 10 ? 1 : 0)} mi` : `${mi.toFixed(1)} mi away`;
  }
  return compact ? `${km.toFixed(km < 10 ? 1 : 0)} km` : `${km.toFixed(1)} km away`;
}

export function formatRadius(km, units) {
  if (units === "mi") return `${Math.round(km * 0.621371)} mi`;
  return `${km} km`;
}
